import { addNewDoctor } from "./addNewDoctorForm";
import { addNewPatient } from "./addNewPatientForm";
import { addNewMedication } from "./addNewMedicationForm";

export const forms = {
  addNewDoctor,
  addNewPatient,
  addNewMedication,
};

export * from "./addNewPatientForm";
export * from "./addNewDoctorForm";
export * from "./addNewMedicationForm";
